import { ErrorBoundary as ReactErrorBoundary, type FallbackProps } from "react-error-boundary";
import type { ReactNode } from "react";

function Fallback({ error }: FallbackProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-steel-50 p-6 text-center">
      <h1 className="mb-4 text-2xl font-bold text-ink">Что-то пошло не так</h1>
      <p className="mb-6 max-w-md text-steel-600">
        Извините, произошла непредвиденная ошибка. Мы уже работаем над ее устранением.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="btn-primary"
      >
        Обновить страницу
      </button>
      {/* Always shown, not gated to development: there is no browser tool
          available to whoever is debugging this in this project, so the
          person who hits the crash is the only source of the actual error
          text. Not a security concern — this is a client-side render error
          message, not server/secret data. */}
      <pre className="mt-8 max-w-full overflow-x-auto whitespace-pre-wrap bg-steel-200 p-4 text-left text-sm text-steel-800">
        {error instanceof Error ? `${error.name}: ${error.message}\n${error.stack ?? ""}` : String(error)}
      </pre>
    </div>
  );
}

export default function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ReactErrorBoundary FallbackComponent={Fallback}>
      {children}
    </ReactErrorBoundary>
  );
}
